// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetShopOrderPagedListRequestViewModel from '../../viewModel/request/ShopOrders/GetShopOrderPagedListRequestViewModel';
import GetShopOrdersByDigitalAssetIdRequestViewModel from '../../viewModel/request/ShopOrders/GetShopOrdersByDigitalAssetIdRequestViewModel';
import ShopOrderResourcePagingResultViewModel from '../../viewModel/resource/ShopOrderResourcePagingResultViewModel';
import ShopOrderResourceViewModel from '../../viewModel/resource/ShopOrderResourceViewModel';
import ShopOrderItemResourceListResultViewModel from '../../viewModel/resource/ShopOrderItemResourceListResultViewModel';
import ShopPaymentResourceListResultViewModel from '../../viewModel/resource/ShopPaymentResourceListResultViewModel';

export default (service: Servicelayer) => ({
  /**  */
  async getShopOrderPagedList(request: GetShopOrderPagedListRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-shop-order-paged-list'] ?? 'ShopOrders';
    const response = await service.get<any>(endpointPath, {
      query: {
        orderStateId: requestDTO.orderStateId,
        dateFrom: requestDTO.dateFrom,
        dateTo: requestDTO.dateTo,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return new ShopOrderResourcePagingResultViewModel().fromDTO(dto);
  },
  /**  */
  async createShopOrder(model: ShopOrderResourceViewModel, config?: RequestConfig) {
    const modelDTO = model.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-create-shop-order'] ?? 'ShopOrders';
    const response = await service.post<any>(endpointPath, {
      body: modelDTO,
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return result as number | undefined;
  },
  /**  */
  async getShopOrdersByDigitalAssetId(id: number, request: GetShopOrdersByDigitalAssetIdRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-shop-orders-by-digital-asset-id'] ?? 'ShopOrders/ByDigitalAssetId/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.get<any>(endpointPath, {
      query: {
        currentPage: requestDTO.currentPage,
        pageSize: requestDTO.pageSize,
        includeCount: requestDTO.includeCount,
        noPaging: requestDTO.noPaging,
      },
      ...config,
    });
    const dto = response.data.result;
    return new ShopOrderResourcePagingResultViewModel().fromDTO(dto);
  },
  /**  */
  async getShopOrder(id: number, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-shop-order'] ?? 'ShopOrders/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new ShopOrderResourceViewModel().fromDTO(dto);
  },
  /**  */
  async updateShopOrder(id: number, model: ShopOrderResourceViewModel, config?: RequestConfig) {
    const modelDTO = model.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-update-shop-order'] ?? 'ShopOrders/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.put<any>(endpointPath, {
      body: modelDTO,
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return result as number | undefined;
  },
  /**  */
  async deleteShopOrder(id: number, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-delete-shop-order'] ?? 'ShopOrders/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.delete<any>(endpointPath, {
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return result as number | undefined;
  },
  /**  */
  async getShopOrderItemList(id: number, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-shop-order-item-list'] ?? 'ShopOrders/{id}/Items';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new ShopOrderItemResourceListResultViewModel().fromDTO(dto);
  },
  /**  */
  async getShopPaymentList(id: number, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-shop-payment-list'] ?? 'ShopOrders/{id}/Payments';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new ShopPaymentResourceListResultViewModel().fromDTO(dto);
  },
});
